import { useState, useEffect, useMemo } from "react";
import SEO from '../../components/SEO';

export default function PricingPage() {
  const isPrerender = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('ReactSnap') !== -1;
  const [show, setShow] = useState(false);
  const [s2, setS2] = useState(false);
  const [s3, setS3] = useState(false);
  const [hov, setHov] = useState(null);
  const [currency, setCurrency] = useState('USD');
  const [billing, setBilling] = useState('hour');

const [scanVis, setScanVis] = useState(isPrerender);
  const [step, setStep] = useState(isPrerender ? 999 : 0);

  const [calcVis, setCalcVis] = useState(isPrerender);
  const [calcProvider, setCalcProvider] = useState('AWS');
  const [calcGpu, setCalcGpu] = useState('H100-SXM5-80GB');
  const [calcCount, setCalcCount] = useState(1);
  const [calcHours, setCalcHours] = useState('168');
  const [calcPreset, setCalcPreset] = useState('168');
  const [calcEmail, setCalcEmail] = useState('');
  const [showCalcEmail, setShowCalcEmail] = useState(false);
  const [calcSending, setCalcSending] = useState(false);
  const [calcSent, setCalcSent] = useState(false);
  const [calcError, setCalcError] = useState('');
  const [showQuote, setShowQuote] = useState(false);
  const [qEmail, setQEmail] = useState('');
  const [qGpu, setQGpu] = useState('H100-SXM5-80GB');
  const [qMonths, setQMonths] = useState('1');
  const [quoteSending, setQuoteSending] = useState(false);
  const [quoteSent, setQuoteSent] = useState(false);
  const [quoteError, setQuoteError] = useState('');
const [barAnim, setBarAnim] = useState(isPrerender);

  const [storVis, setStorVis] = useState(isPrerender);
  const [storHov, setStorHov] = useState(null);
  const [storCur, setStorCur] = useState('USD');

  const [faqVis, setFaqVis] = useState(isPrerender);
  const [faqOpen, setFaqOpen] = useState(null);

  useEffect(() => {
    setTimeout(() => setShow(true), 300);
    setTimeout(() => setS2(true), 700);
    setTimeout(() => setS3(true), 1100);
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const id = e.target.getAttribute('data-section');
          if (id === 'scan') setScanVis(true);
          if (id === 'calc') setCalcVis(true);
          if (id === 'storage') setStorVis(true);
          if (id === 'faq') setFaqVis(true);
        }
      });
    }, { threshold: 0.15 });
    document.querySelectorAll('[data-section]').forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    if (scanVis && step < 14) {
      const delays = [0,300,600,1200,1900,2500,3200,3800,4500,5100,5800,6200,6400,6700];
      if (step === 0) {
        const t = delays.map((d, i) => setTimeout(() => setStep(i + 1), d));
        return () => t.forEach(clearTimeout);
      }
    }
  }, [scanVis]);

  useEffect(() => {
    setBarAnim(false);
    const t = setTimeout(() => setBarAnim(true), 400);
    return () => clearTimeout(t);
  }, [calcProvider, calcGpu, calcCount, calcHours]);

  useEffect(() => {
    setShowCalcEmail(false);
    setCalcSent(false);
    setCalcError('');
    setCalcEmail('');
  }, [calcProvider, calcGpu, calcCount, calcHours]);

  const cs = { USD: '$', EUR: '€', INR: '₹' };
  const accent = '#e0eacc';
  const mono = "'SF Mono','Fira Code','Cascadia Code','Courier New',monospace";

  const gpuList = [
    { m: 'B300-262GB', p: { USD: 8.99, EUR: 9.65, INR: 899 } },
    { m: 'B200-180GB', p: { USD: 6.89, EUR: 7.39, INR: 689 } },
    { m: 'H200-141GB', p: { USD: 4.45, EUR: 4.79, INR: 445 } },
    { m: 'H100-SXM5-80GB', p: { USD: 3.59, EUR: 3.89, INR: 359 } },
    { m: 'H100-PCIe-NVLink-80GB', p: { USD: 3.19, EUR: 3.45, INR: 319 } },
    { m: 'H100-PCIe-80GB', p: { USD: 2.89, EUR: 3.09, INR: 289 } },
    { m: 'A100-PCIe-80GB', p: { USD: 1.49, EUR: 1.59, INR: 149 } },
    { m: 'L40', p: { USD: 1.19, EUR: 1.29, INR: 119 } },
    { m: 'RTX-A6000', p: { USD: 0.59, EUR: 0.65, INR: 59 } },
  ];

  const BP = { 'B300-262GB': 7.99, 'B200-180GB': 5.15, 'H200-141GB': 3.49, 'H100-PCIe-80GB': 1.99, 'H100-SXM5-80GB': 2.69 };
  const CP = {
    'AWS': { 'B300-262GB': 17.80, 'B200-180GB': 14.24, 'H200-141GB': 7.912, 'H100-PCIe-80GB': null, 'H100-SXM5-80GB': 6.88 },
    'CoreWeave': { 'B300-262GB': null, 'B200-180GB': 8.60, 'H200-141GB': 6.31, 'H100-PCIe-80GB': null, 'H100-SXM5-80GB': 6.16 },
    'Lambda Labs': { 'B300-262GB': null, 'B200-180GB': 5.29, 'H200-141GB': null, 'H100-PCIe-80GB': 2.49, 'H100-SXM5-80GB': 3.29 },
  };
  const NAMES = { 'B300-262GB': 'NVIDIA B300 (262GB)', 'B200-180GB': 'NVIDIA B200 (180GB)', 'H200-141GB': 'NVIDIA H200 (141GB)', 'H100-PCIe-80GB': 'NVIDIA H100 PCIe (80GB)', 'H100-SXM5-80GB': 'NVIDIA H100 SXM5 (80GB)' };
  const MAX = { 'B300-262GB': 8, 'B200-180GB': 8, 'H200-141GB': 8, 'H100-PCIe-80GB': 8, 'H100-SXM5-80GB': 8 };
  const gpuKeys = Object.keys(BP);
  const showCustom = calcHours && parseFloat(calcHours) >= 730;
  const hasGpu = calcProvider && calcGpu && CP[calcProvider]?.[calcGpu] !== null;
  const exclusive = calcProvider && calcGpu && !hasGpu;

  const calc = useMemo(() => {
    if (!calcProvider || !calcGpu || !calcHours || parseFloat(calcHours) <= 0 || showCustom) return null;
    const cp = CP[calcProvider]?.[calcGpu]; const bp = BP[calcGpu];
    if (!cp || !bp) return null;
    const h = parseFloat(calcHours); const cc = cp * calcCount * h; const bc = bp * calcCount * h;
    return { cc, bc, sv: cc - bc, pct: ((cc - bc) / cc) * 100 };
  }, [calcProvider, calcGpu, calcCount, calcHours, showCustom]);

  const storRows = [
    { label: 'SSD', tier: 'Legacy', p: { USD: 0.10, EUR: 0.10, INR: 10 } },
    { label: 'Snapshot', tier: 'Legacy', p: { USD: 0.10, EUR: 0.10, INR: 10 }, note: 'fixed 100GB' },
    { label: 'NVMe', tier: 'Advanced', p: { USD: 0.3, EUR: 0.35, INR: 30.0 } },
    { label: 'HDD', tier: 'Advanced', p: { USD: 0.08, EUR: 0.1, INR: 8.0 } },
  ];

  const fees = [
    { name: 'Data Egress', ds: 3, dn: 4 }, { name: 'Public IP', ds: 5, dn: 6 },
    { name: 'Networking', ds: 7, dn: 8 }, { name: 'Commitment Fee', ds: 9, dn: 10 },
  ];

 const faqs = [
    { q: "How are your prices so competitive?", a: "All our instances are on-demand at competitive rates. Unlike other GPU cloud providers that advertise low prices through spot instances — where your workload can be terminated mid-run without warning, causing data loss and frustration — every instance on Barrack is fully dedicated to you for as long as you need it. No unexpected interruptions, no bidding, no surprises. You get the right price with the reliability to actually finish your work." },
    { q: "When do I start getting charged?", a: "Billing starts once your instance status is Running. Instances in Running and Shutoff status continue to be billed for compute resources. Transitional states are not billed." },
    { q: "How do I stop getting charged after I deploy?", a: "To stop billing for an instance, you need to either hibernate or delete it. Simply shutting down your instance does not pause billing — instances in Shutoff status continue to be billed for compute resources." },
    { q: "What happens when my balance runs out?", a: "Your resources (instances, volumes, and snapshots) will continue running for a limited grace period. You have up to 24 hours or until your balance reaches -$10 USD / -€10 EUR / -₹500 INR — whichever comes first — to add credits. If credits are not added before either threshold is reached, all resources will be permanently deleted and cannot be recovered." },
    { q: "What if I need a GPU that's not listed, want to negotiate rates, or need bare metal?", a: "Whether you're looking for a specific GPU not currently on our platform, need volume pricing or longer-term commitments, or require bare metal infrastructure — contact us at support@barrack.ai and our team will assist you." },
    { q: "Do you accept bank transfers?", a: "Yes. We support international bank transfers via SWIFT, ACH (USD), SEPA (EUR), FPS (GBP), and DKK. For bank transfer payments, please contact us at support@barrack.ai and we'll share the relevant account details based on your currency." },
  ];

  const getPrice = (p) => { const raw = p[currency]; return billing === 'minute' ? (raw / 60).toFixed(5) : raw; };
  const fmt = v => v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const fade = (on, d = 0) => ({ opacity: on ? 1 : 0, transform: on ? 'translateY(0)' : 'translateY(25px)', transition: `all 0.9s cubic-bezier(0.25,0.46,0.45,0.94) ${d}s` });
  const fH = (v) => storCur === 'INR' ? (v % 1 === 0 ? v.toFixed(0) : v.toFixed(1)) : v.toFixed(2);
  const ex100 = (hr) => { const mo = hr * (100 / 1024) * 730; return storCur === 'INR' ? mo.toFixed(0) : mo.toFixed(2); };
  const labelStyle = { display: 'block', fontSize: '11px', fontWeight: 600, color: 'rgba(202,217,227,0.45)', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' };
  const selectStyle = { width: '100%', backgroundColor: 'rgba(10,26,46,0.6)', border: '1px solid rgba(224,234,204,0.1)', borderRadius: '8px', padding: '12px 14px', color: '#fff', fontSize: '15px', fontWeight: 500, outline: 'none', cursor: 'pointer', appearance: 'none', transition: 'border-color 0.2s ease', backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23cad9e3' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center', backgroundSize: '14px', minHeight: '48px' };
  const pillStyle = (a) => ({ padding: '10px 18px', borderRadius: '6px', fontSize: '13px', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s ease', border: 'none', background: a ? accent : 'rgba(10,26,46,0.6)', color: a ? '#000' : 'rgba(202,217,227,0.6)', boxShadow: a ? '0 0 12px rgba(224,234,204,0.15)' : 'none', minHeight: '44px' });

  const cursor = <span style={{ display: 'inline-block', width: '8px', height: '15px', background: accent, animation: 'blink 1s step-end infinite', verticalAlign: 'middle' }} />;

  const handleSendComparison = async () => {
    if (!calcEmail || !calc) return;
    setCalcSending(true);
    setCalcError('');
    try {
      const providerRate = CP[calcProvider]?.[calcGpu];
      const barrackRate = BP[calcGpu];
      const res = await fetch('/api/v1/contact/comparison/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: calcEmail,
          provider: calcProvider,
          gpu_model: calcGpu,
          gpu_count: calcCount,
          hours: parseFloat(calcHours),
          provider_cost: calc.cc,
          barrack_cost: calc.bc,
          provider_rate: providerRate,
          barrack_rate: barrackRate,
        })
      });
      const data = await res.json();
      if (data.success) {
        setCalcSent(true);
        setTimeout(() => { setShowCalcEmail(false); setCalcSent(false); setCalcEmail(''); }, 3000);
      } else {
        setCalcError(data.message || 'Something went wrong.');
      }
    } catch (err) {
      setCalcError('Something went wrong. Try again.');
    } finally {
      setCalcSending(false);
    }
  };

  const handleSendQuote = async () => {
    if (!qEmail) return;
    setQuoteSending(true);
    setQuoteError('');
    try {
      const gpuName = NAMES[qGpu] || qGpu;
      const msg = `[Quote Request] GPU: ${gpuName} | Duration: ${qMonths} month${qMonths !== '1' ? 's' : ''}`;
      const res = await fetch('/api/v1/contact/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: qEmail, message: msg })
      });
      const data = await res.json();
      if (data.success) {
        setQuoteSent(true);
        setTimeout(() => { setShowQuote(false); setQuoteSent(false); setQEmail(''); setQMonths('1'); }, 2500);
      } else {
        setQuoteError(data.message || 'Something went wrong.');
      }
    } catch (err) {
      setQuoteError('Something went wrong. Try again.');
    } finally {
      setQuoteSending(false);
    }
  };

  return (
    <>
      <SEO
        title="GPU Cloud Pricing — Per-Minute Billing, No Contracts"
        description="H200, B200 and B300 available. No hidden fees. No egress charges. No commitments. Billed by the minute."
        path="/pricing"
      />
      <style>{`
        html{scroll-behavior:smooth;box-sizing:border-box}
        *,*::before,*::after{box-sizing:inherit}
        @keyframes pulseGlow{0%,100%{box-shadow:0 0 6px rgba(224,234,204,0.15)}50%{box-shadow:0 0 18px rgba(224,234,204,0.35)}}
        @keyframes blink{0%,100%{opacity:1}50%{opacity:0}}
        @keyframes popIn{0%{transform:scale(0.5);opacity:0}100%{transform:scale(1);opacity:1}}
        @keyframes dotPulse{0%,100%{opacity:0.3}50%{opacity:0.8}}
        @keyframes shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}

        /* ── DESKTOP DEFAULTS ── */
        .p-hero-grid{display:grid;grid-template-columns:1fr 1fr;gap:48px;align-items:center}
        .p-hero-text{text-align:left}
        .p-hero-pad{padding:80px 32px}
        .p-hero-right{display:flex;flex-direction:column;align-items:flex-end}
        .p-gpu-card{width:100%;max-width:450px}
        .p-cur-toggle{display:flex;border-radius:12px;overflow:hidden}
        .p-billing-toggle{display:flex;border-radius:12px;overflow:hidden;background:#050a14}
        .p-billing-btn{width:112px;padding:8px 16px;font-size:14px;font-weight:500;border:none;cursor:pointer;transition:all 0.2s ease;white-space:nowrap;min-height:44px}
        .p-gpu-row{display:flex;justify-content:space-between;align-items:center}
        .p-section-pad{padding:100px 0 120px}
        .p-section-inner{padding:0 32px}
        .p-scan-inner{max-width:600px;margin:0 auto}
        .p-scan-code{padding:28px;font-size:13px;line-height:2.2}
        .p-calc-inner{max-width:930px;margin:0 auto}
        .p-calc-config{padding:24px 32px;border-bottom:1px solid rgba(202,217,227,0.06);display:flex;flex-direction:column;gap:16px}
        .p-calc-row{display:grid;grid-template-columns:1fr 1fr;gap:16px}
        .p-calc-result{padding:22px 32px}
        .p-calc-bars{display:grid;grid-template-columns:1fr 1fr;gap:24px;margin-bottom:28px}
        .p-calc-cta{display:flex;justify-content:center;gap:12px;margin-top:24px;flex-wrap:wrap}
        .p-calc-email-row{display:flex;gap:6px}
        .p-calc-email-input{width:200px}
        .p-pill-row{display:flex;gap:4px;flex-wrap:wrap}
        .p-stor-inner{max-width:760px;margin:0 auto}
        .p-stor-header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:48px;flex-wrap:wrap;gap:20px}
        .p-stor-grid{display:grid;grid-template-columns:1.4fr 0.8fr 1fr 1fr;padding:16px 28px}
        .p-stor-row{display:grid;grid-template-columns:1.4fr 0.8fr 1fr 1fr;padding:20px 28px;align-items:center}
        .p-stor-notes{display:flex;gap:24px;justify-content:center;flex-wrap:wrap;margin-top:28px}
        .p-faq-inner{max-width:700px;margin:0 auto}
        .p-faq-btn{min-height:56px}
        .p-footer-inner{max-width:900px;margin:0 auto;display:flex;flex-direction:column;align-items:center;gap:20px}
        .p-footer-links{display:flex;gap:24px;flex-wrap:wrap;justify-content:center}
        .p-quote-modal{width:100%;max-width:420px;position:relative;margin:0 16px}
        .p-quote-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}
        .p-cta-row{display:flex;flex-wrap:wrap;gap:16px}
        .p-cta-row a,.p-cta-row button{min-width:auto;text-align:center}
        .p-savings-num{font-size:50px}

        /* ── TABLET ── */
        @media(max-width:1024px){
          .p-hero-grid{grid-template-columns:1fr;gap:40px}
          .p-hero-text{text-align:center}
          .p-hero-text p{margin-left:auto;margin-right:auto}
          .p-cta-row{justify-content:center}
          .p-hero-right{align-items:center}
          .p-gpu-card{max-width:520px}
          .p-section-pad{padding:80px 0 100px}
        }

        /* ── MOBILE ── */
        @media(max-width:767px){
          .p-hero-grid{grid-template-columns:1fr;gap:36px}
          .p-hero-pad{padding:56px 24px 64px}
          .p-hero-text{text-align:center}
          .p-hero-text p{margin-left:auto;margin-right:auto;max-width:100%}
          .p-hero-right{align-items:stretch}
          .p-gpu-card{max-width:100%;padding:20px !important}
          .p-cur-toggle{width:100%}
          .p-cur-toggle button{flex:1;padding:10px 12px !important;font-size:13px !important;min-height:44px}
          .p-billing-toggle{width:100%}
          .p-billing-btn{flex:1;width:auto;min-height:44px}
          .p-gpu-row{flex-direction:row;align-items:center;gap:8px;padding:10px 0;min-height:44px}
          .p-gpu-row span:first-child{font-size:13px !important;flex:1}
          .p-gpu-row span:last-child{font-size:14px !important;white-space:nowrap}
          .p-section-pad{padding:72px 0 88px}
          .p-section-inner{padding:0 24px}
          .p-cta-row{flex-direction:column;gap:12px}
          .p-cta-row button,.p-cta-row a{width:100%;text-align:center;padding:16px 28px !important;font-size:16px !important;border-radius:12px !important;min-height:52px}
          .p-scan-code{padding:18px;font-size:11.5px;line-height:2;overflow-x:auto;word-break:break-all}
          .p-calc-config{padding:20px;gap:16px}
          .p-calc-row{grid-template-columns:1fr;gap:16px}
          .p-calc-result{padding:20px}
          .p-calc-bars{grid-template-columns:1fr;gap:16px}
          .p-calc-cta{flex-direction:column;align-items:stretch}
          .p-calc-cta a,.p-calc-cta button{width:100%;text-align:center;padding:14px 28px !important;font-size:15px !important;border-radius:10px !important;min-height:48px}
          .p-calc-email-row{flex-direction:column;width:100%}
          .p-calc-email-input{width:100% !important}
          .p-pill-row{flex-wrap:wrap;gap:6px}
          .p-pill-row button{flex:1;min-width:0;text-align:center}
          .p-stor-header{flex-direction:column;gap:16px;margin-bottom:36px}
          .p-stor-grid{grid-template-columns:1fr 1fr;gap:8px;padding:14px 20px}
          .p-stor-grid .p-stor-col-tier,.p-stor-grid .p-stor-col-mo{display:none}
          .p-stor-row{grid-template-columns:1fr 1fr;gap:8px;padding:18px 20px}
          .p-stor-row .p-stor-cell-tier,.p-stor-row .p-stor-cell-mo{display:none}
          .p-faq-inner{max-width:100%}
          .p-faq-btn{min-height:60px;padding:20px 0 !important}
          .p-footer-links{gap:20px}
          .p-quote-modal{margin:0 16px;max-width:100%;padding:32px 24px !important}
          .p-quote-grid{grid-template-columns:1fr}
          .p-savings-num{font-size:42px}
        }

        /* ── SMALL MOBILE ── */
        @media(max-width:399px){
          .p-hero-pad{padding:44px 16px 52px}
          .p-section-inner{padding:0 16px}
          .p-section-pad{padding:56px 0 72px}
          .p-scan-code{padding:14px;font-size:10.5px;line-height:1.9}
          .p-calc-config{padding:16px}
          .p-calc-result{padding:16px}
          .p-stor-grid{padding:12px 16px}
          .p-stor-row{padding:14px 16px}
          .p-savings-num{font-size:36px}
          .p-gpu-card{padding:16px !important}
          .p-quote-modal{padding:28px 16px !important}
        }
      `}</style>

      <div style={{ background: '#000', fontFamily: 'Inter, system-ui, -apple-system, sans-serif' }}>

        {/* ═══ S1: HERO ═══ */}
        <section style={{ background: '#040911', position: 'relative', overflow: 'hidden', minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
          <div style={{ position: 'absolute', top: '80px', right: '10%', width: '384px', height: '384px', background: '#0a1a2e', opacity: 0.25, borderRadius: '50%', filter: 'blur(60px)' }} />
          <div style={{ position: 'absolute', top: '-40px', left: '-80px', width: '288px', height: '288px', background: '#0a1a2e', opacity: 0.2, borderRadius: '50%', filter: 'blur(60px)' }} />
          <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', height: '70%', background: accent, opacity: 0.07, borderRadius: '100% 100% 0 0', filter: 'blur(60px)' }} />
          <div style={{ position: 'absolute', bottom: '-40px', right: '40px', width: '384px', height: '384px', background: accent, opacity: 0.05, borderRadius: '50%', filter: 'blur(60px)' }} />
          <div className="p-hero-grid p-hero-pad" style={{ maxWidth: '1280px', width: '100%', margin: '0 auto', position: 'relative', zIndex: 10 }}>
            <div className="p-hero-text">
<h1 style={{ fontSize: 'clamp(30px, 4.2vw, 52px)', fontWeight: 700, lineHeight: 1.12, color: '#fff', margin: '0 0 24px 0', ...fade(show) }}>The Longer You Stay,<br />The Less You <span style={{ color: accent }}>Pay.</span></h1>              <p style={{ fontSize: 'clamp(15px, 1.8vw, 18px)', color: 'rgba(202,217,227,0.7)', lineHeight: 1.65, margin: '0 0 36px 0', maxWidth: '480px', ...fade(s2) }}>With Barrack, your instance doesn't get killed mid-run. On-demand GPUs, down to the minute. No egress fees.</p>
              <div className="p-cta-row" style={fade(s3)}>
                <a href="https://barrack.ai/signup" onMouseEnter={() => setHov('start')} onMouseLeave={() => setHov(null)} style={{ background: accent, color: '#000', border: 'none', borderRadius: '8px', padding: '14px 28px', fontSize: '15px', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s ease', transform: hov === 'start' ? 'translateY(-1px)' : 'none', boxShadow: hov === 'start' ? '0 8px 24px rgba(224,234,204,0.2)' : 'none', textDecoration: 'none', display: 'inline-block' }}>Get Started</a>
              </div>
            </div>
            <div className="p-hero-right" style={fade(s2)}>
              <div className="p-cur-toggle" style={{ marginBottom: '16px' }}>
                {['USD', 'EUR', 'INR'].map(c => (
                  <button key={c} onClick={() => setCurrency(c)} style={{ padding: '10px 28px', fontSize: '14px', fontWeight: 500, border: 'none', cursor: 'pointer', transition: 'all 0.2s ease', background: currency === c ? accent : '#060d18', color: currency === c ? '#000' : 'rgba(202,217,227,0.6)', minHeight: '44px' }}>{c} ({cs[c]})</button>
                ))}
              </div>
              <div className="p-gpu-card" style={{ background: '#060d18', border: '0.25px solid #555555', borderRadius: '12px', padding: '24px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
                  <h3 style={{ fontSize: '20px', fontWeight: 600, color: '#fff', margin: 0 }}>GPU Pricing</h3>
                  <div className="p-billing-toggle">
                    {['hour', 'minute'].map(b => (
                      <button key={b} onClick={() => setBilling(b)} className="p-billing-btn" style={{ background: billing === b ? accent : 'transparent', color: billing === b ? '#000' : 'rgba(202,217,227,0.6)' }}>Per {b}</button>
                    ))}
                  </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  {gpuList.map(g => (
                    <div key={g.m} className="p-gpu-row">
                      <span style={{ fontSize: '14px', color: 'rgba(202,217,227,0.85)' }}>{g.m}</span>
                      <span style={{ fontSize: '14px', fontWeight: 500, color: '#fff' }}>{cs[currency]}{getPrice(g.p)}/{billing}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ═══ S3: YOUR BILL (SCAN) ═══ */}
        <section data-section="scan" className="p-section-pad" style={{ background: '#040911', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: '600px', height: '600px', background: 'radial-gradient(circle, rgba(224,234,204,0.03) 0%, transparent 70%)', borderRadius: '50%' }} />
          <div className="p-scan-inner p-section-inner" style={{ position: 'relative', zIndex: 10 }}>
            <div style={{ textAlign: 'center', marginBottom: '48px', ...fade(scanVis) }}>
              <h2 style={{ fontSize: 'clamp(26px, 3.5vw, 42px)', fontWeight: 700, color: '#fff', marginBottom: '14px', letterSpacing: '-1px' }}>Your Bill. <span style={{ color: accent }}>Guaranteed.</span></h2>
              <p style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', color: 'rgba(202,217,227,0.45)' }}>No hidden fees. No surprise line items. What you see is what you pay.</p>
            </div>
            <div style={{ background: '#0a0e14', border: '1px solid rgba(202,217,227,0.1)', borderRadius: '12px', overflow: 'hidden', opacity: scanVis ? 1 : 0, transform: scanVis ? 'translateY(0)' : 'translateY(20px)', transition: 'all 0.8s ease 0.3s' }}>
              <div style={{ background: 'rgba(202,217,227,0.04)', padding: '10px 16px', display: 'flex', alignItems: 'center', gap: '8px', borderBottom: '1px solid rgba(202,217,227,0.06)' }}>
                <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: 'rgba(204,85,85,0.6)' }} />
                <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: 'rgba(202,177,85,0.6)' }} />
                <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: 'rgba(85,204,120,0.6)' }} />
                <span style={{ fontSize: '11px', color: 'rgba(202,217,227,0.3)', marginLeft: '8px', fontFamily: mono }}>barrack billing --verify</span>
              </div>
              <div className="p-scan-code" style={{ fontFamily: mono }}>
                {step >= 1 && <div style={{ color: 'rgba(202,217,227,0.4)' }}>$ barrack billing --verify</div>}
                {step >= 2 && <div style={{ height: '8px' }} />}
                {step >= 2 && step < 4 && <div style={{ color: 'rgba(202,217,227,0.35)', animation: 'dotPulse 1.2s ease infinite' }}>Verifying charges...</div>}
                {step >= 4 && <div style={{ color: 'rgba(202,217,227,0.35)' }}>Verifying charges...</div>}
                {step >= 3 && <div style={{ height: '8px' }} />}
                {fees.map((f, i) => {
                  if (step < f.ds) return null;
                  const done = step >= f.dn;
                  const dots = '·'.repeat(32 - f.name.length);
                  return (
                    <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '4px' }}>
                      <span><span style={{ color: 'rgba(202,217,227,0.5)' }}>  {f.name} </span><span style={{ color: 'rgba(202,217,227,0.15)', animation: !done ? 'dotPulse 0.8s ease infinite' : 'none' }}>{dots}</span></span>
                      {done ? <span style={{ color: accent, fontWeight: 700, animation: 'popIn 0.3s ease' }}>$0.00</span> : <span style={{ color: 'rgba(202,217,227,0.2)', animation: 'dotPulse 0.6s ease infinite' }}>···</span>}
                    </div>
                  );
                })}
                {step >= 11 && <div style={{ height: '8px' }} />}
                {step >= 12 && <div style={{ borderTop: '1px dashed rgba(202,217,227,0.08)', margin: '4px 0' }} />}
                {step >= 13 && <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px', flexWrap: 'wrap', gap: '4px' }}><span style={{ color: 'rgba(202,217,227,0.4)' }}>  additional_charges:</span><span style={{ color: accent, fontWeight: 800, fontSize: '16px', animation: 'popIn 0.3s ease' }}>0</span></div>}
                {step >= 14 && <div style={{ marginTop: '8px', color: 'rgba(85,204,120,0.7)', fontSize: '12px' }}>[PASS] Verified. Your bill is clean.</div>}
                {step < 14 && <div style={{ marginTop: '8px' }}>{cursor}</div>}
              </div>
            </div>
            {step >= 14 && <div style={{ textAlign: 'center', marginTop: '40px', animation: 'popIn 0.5s ease' }}><p style={{ fontSize: 'clamp(15px, 1.7vw, 17px)', color: 'rgba(202,217,227,0.5)', margin: 0 }}>If it's not on our pricing page, it's not on your invoice. <span style={{ color: '#fff', fontWeight: 600 }}>Period.</span></p></div>}
          </div>
        </section>

        {/* ═══ S4: SAVINGS CALCULATOR ═══ */}
        <section data-section="calc" style={{ background: '#000', position: 'relative', overflow: 'hidden', padding: '90px 0 108px' }}>
          <div style={{ position: 'absolute', top: '10%', right: '-8%', width: '500px', height: '500px', background: 'radial-gradient(circle, rgba(10,26,46,0.4) 0%, transparent 70%)', borderRadius: '50%' }} />
          <div style={{ position: 'absolute', bottom: '10%', left: '-5%', width: '400px', height: '400px', background: 'radial-gradient(circle, rgba(224,234,204,0.025) 0%, transparent 70%)', borderRadius: '50%' }} />
          <div className="p-calc-inner p-section-inner" style={{ position: 'relative', zIndex: 10 }}>
            <div style={fade(calcVis)}>
              <h2 style={{ fontSize: 'clamp(26px, 3.5vw, 42px)', fontWeight: 700, color: '#fff', marginBottom: '10px', letterSpacing: '-1px' }}>See The <span style={{ color: accent }}>Difference.</span></h2>
              <p style={{ fontSize: 'clamp(13px, 1.5vw, 15px)', color: 'rgba(202,217,227,0.4)', margin: '0 0 56px 0' }}>Don't take our word for it.</p>
            </div>
            <div style={{ background: '#050b15', border: '1px solid rgba(202,217,227,0.08)', borderRadius: '16px', overflow: 'hidden', ...fade(calcVis, 0.3) }}>
              <div className="p-calc-config">
                <div className="p-calc-row">
                  <div>
                    <label style={labelStyle}>Compare Against</label>
                    <select value={calcProvider} onChange={e => setCalcProvider(e.target.value)} style={selectStyle}>
                      <option value="AWS" style={{ background: '#040911' }}>AWS</option>
                      <option value="CoreWeave" style={{ background: '#040911' }}>CoreWeave</option>
                      <option value="Lambda Labs" style={{ background: '#040911' }}>Lambda Labs</option>
                    </select>
                  </div>
                  <div>
                    <label style={labelStyle}>GPU Model</label>
                    <select value={calcGpu} onChange={e => setCalcGpu(e.target.value)} style={selectStyle}>
                      {gpuKeys.map(g => <option key={g} value={g} style={{ background: '#040911' }}>{NAMES[g]}</option>)}
                    </select>
                  </div>
                </div>
                <div className="p-calc-row">
                  <div>
                    <label style={labelStyle}>GPUs</label>
                    <div className="p-pill-row">
                      {[1,2,4,8].filter(c => c <= (MAX[calcGpu]||8)).map(c => (
                        <button key={c} onClick={() => setCalcCount(c)} style={pillStyle(calcCount===c)}>{c}×</button>
                      ))}
                    </div>
                  </div>
                  <div>
                    <label style={labelStyle}>Duration</label>
                    <div className="p-pill-row">
                      {[{l:'1D',v:'24'},{l:'1W',v:'168'},{l:'1M',v:'730'},{l:'Custom',v:'custom'}].map(p => (
                        <button key={p.v} onClick={() => {setCalcPreset(p.v);if(p.v!=='custom')setCalcHours(p.v);else setCalcHours('');}} style={pillStyle(calcPreset===p.v)}>{p.l}</button>
                      ))}
                    </div>
                    {calcPreset==='custom' && (
                      <input type="number" value={calcHours} onChange={e=>setCalcHours(e.target.value)} placeholder="Enter hours" min="1" style={{ width: '100%', maxWidth: '200px', marginTop: '10px', backgroundColor: 'rgba(10,26,46,0.6)', border: '1px solid rgba(224,234,204,0.1)', borderRadius: '8px', padding: '12px 14px', color: '#fff', fontSize: '15px', outline: 'none', boxSizing: 'border-box', minHeight: '48px' }} />
                    )}
                  </div>
                </div>
              </div>

              <div className="p-calc-result">
                {showCustom && !exclusive && (
                  <div style={{ textAlign: 'center', padding: '48px 24px' }}>
                    <div style={{ fontSize: '14px', color: 'rgba(202,217,227,0.4)', marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '1.5px', fontWeight: 600 }}>Extended Usage</div>
                    <div style={{ fontSize: '24px', fontWeight: 700, color: '#fff', marginBottom: '8px' }}>Let's talk.</div>
                    <div style={{ fontSize: 'clamp(13px, 1.5vw, 15px)', color: 'rgba(202,217,227,0.5)', marginBottom: '28px', maxWidth: '360px', margin: '0 auto 28px' }}>For 1 month+ usage, we tailor pricing to your workload.</div>
                    <button onClick={() => {setQGpu(calcGpu);setShowQuote(true);}} onMouseEnter={() => setHov('cq')} onMouseLeave={() => setHov(null)} style={{ background: accent, color: '#000', border: 'none', borderRadius: '8px', padding: '14px 32px', fontSize: '15px', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s ease', transform: hov==='cq'?'translateY(-1px)':'none', boxShadow: hov==='cq'?'0 8px 24px rgba(224,234,204,0.2)':'none', minHeight: '48px' }}>Get Custom Quote</button>
                  </div>
                )}

                {exclusive && (
                  <div style={{ textAlign: 'center', padding: '48px 24px' }}>
                    <div style={{ display: 'inline-block', padding: '5px 16px', borderRadius: '20px', background: 'linear-gradient(90deg, rgba(224,234,204,0.1), rgba(224,234,204,0.2), rgba(224,234,204,0.1))', backgroundSize: '200% 100%', animation: 'shimmer 3s infinite linear', border: '1px solid rgba(224,234,204,0.2)', color: accent, fontSize: '12px', fontWeight: 600, letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '20px' }}>Only on Barrack</div>
                    <div style={{ fontSize: 'clamp(18px, 2.2vw, 22px)', fontWeight: 700, color: '#fff', marginBottom: '8px' }}>{NAMES[calcGpu]}</div>
                    <div style={{ fontSize: 'clamp(13px, 1.5vw, 15px)', color: 'rgba(202,217,227,0.5)' }}>{calcProvider} doesn't offer this GPU.</div>
                    <div style={{ marginTop: '16px' }}>
                      <span style={{ fontSize: 'clamp(22px, 3vw, 28px)', fontWeight: 700, color: accent }}>${BP[calcGpu]}</span>
                      <span style={{ fontSize: '14px', color: 'rgba(202,217,227,0.4)', marginLeft: '4px' }}>/hr per GPU</span>
                      {calcCount > 1 && <div style={{ fontSize: '13px', color: 'rgba(202,217,227,0.35)', marginTop: '4px' }}>{calcCount}× = ${(BP[calcGpu]*calcCount).toFixed(2)}/hr</div>}
                    </div>
                  </div>
                )}

                {calc && (
                  <div>
                    <div className="p-calc-bars">
                      <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '10px' }}>
                          <span style={{ fontSize: '13px', color: 'rgba(202,217,227,0.5)' }}>{calcProvider}</span>
                          <span style={{ fontFamily: mono, fontSize: '15px', fontWeight: 600, color: 'rgba(204,85,85,0.7)' }}>${fmt(calc.cc)}</span>
                        </div>
                        <div style={{ background: 'rgba(204,85,85,0.1)', borderRadius: '6px', height: '10px', overflow: 'hidden' }}>
                          <div style={{ background: 'linear-gradient(90deg, rgba(204,85,85,0.6), rgba(204,85,85,0.3))', borderRadius: '6px', height: '100%', width: barAnim?'100%':'0%', transition: 'width 1s cubic-bezier(0.25,0.46,0.45,0.94) 0.2s' }} />
                        </div>
                      </div>
                      <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '10px' }}>
                          <span style={{ fontSize: '13px', color: 'rgba(202,217,227,0.5)' }}>Barrack</span>
                          <span style={{ fontFamily: mono, fontSize: '15px', fontWeight: 600, color: accent }}>${fmt(calc.bc)}</span>
                        </div>
                        <div style={{ background: 'rgba(224,234,204,0.08)', borderRadius: '6px', height: '10px', overflow: 'hidden' }}>
                          <div style={{ background: `linear-gradient(90deg, ${accent}, rgba(224,234,204,0.5))`, borderRadius: '6px', height: '100%', width: barAnim?`${(calc.bc/calc.cc)*100}%`:'0%', transition: 'width 1.2s cubic-bezier(0.25,0.46,0.45,0.94) 0.4s' }} />
                        </div>
                      </div>
                    </div>

                    <div style={{ background: 'rgba(224,234,204,0.04)', border: '1px solid rgba(224,234,204,0.08)', borderRadius: '12px', padding: '22px 24px', textAlign: 'center' }}>
                      <div className="p-savings-num" style={{ fontWeight: 700, color: accent, lineHeight: 1, letterSpacing: '-3px' }}>{calc.pct.toFixed(0)}<span style={{ fontSize: '0.54em' }}>%</span></div>
                      <div style={{ fontSize: '14px', color: 'rgba(202,217,227,0.5)', marginTop: '10px' }}>That's <span style={{ color: accent, fontWeight: 600 }}>${fmt(calc.sv)}</span> saved.</div>
                    </div>

                    <div className="p-calc-cta">
                      <a href="https://barrack.ai/signup" onMouseEnter={() => setHov('sd')} onMouseLeave={() => setHov(null)} style={{ background: accent, color: '#000', border: 'none', borderRadius: '8px', padding: '11px 28px', fontSize: '13px', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s ease', transform: hov==='sd'?'translateY(-1px)':'none', boxShadow: hov==='sd'?'0 8px 24px rgba(224,234,204,0.2)':'none', textDecoration: 'none', display: 'inline-block' }}>Get Started</a>
                      {calcSent ? (
                        <div style={{ padding: '11px 28px', fontSize: '13px', fontWeight: 600, color: 'rgba(85,204,120,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✓ Check your inbox</div>
                      ) : !showCalcEmail ? (
                        <button onClick={() => setShowCalcEmail(true)} onMouseEnter={() => setHov('em')} onMouseLeave={() => setHov(null)} style={{ background: 'transparent', color: 'rgba(202,217,227,0.5)', border: '1px solid rgba(202,217,227,0.1)', borderRadius: '8px', padding: '11px 28px', fontSize: '13px', fontWeight: 500, cursor: 'pointer', transition: 'all 0.2s ease', transform: hov==='em'?'translateY(-1px)':'none' }}>Email Me This</button>
                      ) : (
                        <div style={{ width: '100%' }}>
                          <div className="p-calc-email-row">
                            <input type="email" value={calcEmail} onChange={e => setCalcEmail(e.target.value)} placeholder="you@company.com" className="p-calc-email-input" style={{ backgroundColor: 'rgba(10,26,46,0.6)', border: '1px solid rgba(224,234,204,0.15)', borderRadius: '8px', padding: '12px 14px', color: '#fff', fontSize: '14px', outline: 'none', boxSizing: 'border-box', minHeight: '48px' }} onKeyDown={e => { if (e.key === 'Enter') handleSendComparison(); }} />
                            <button onClick={handleSendComparison} disabled={calcSending || !calcEmail} style={{ background: accent, color: '#000', border: 'none', borderRadius: '8px', padding: '12px 16px', fontSize: '14px', fontWeight: 600, cursor: calcSending || !calcEmail ? 'not-allowed' : 'pointer', whiteSpace: 'nowrap', opacity: calcSending || !calcEmail ? 0.5 : 1, minHeight: '48px' }}>{calcSending ? 'Sending...' : 'Send'}</button>
                          </div>
                          {calcError && <div style={{ fontSize: '12px', color: 'rgba(204,85,85,0.7)', marginTop: '6px', textAlign: 'center' }}>{calcError}</div>}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {!calc && !showCustom && !exclusive && (
                  <div style={{ textAlign: 'center', padding: '48px 24px' }}>
                    <div style={{ fontSize: 'clamp(13px, 1.5vw, 15px)', color: 'rgba(202,217,227,0.3)' }}>Pick a provider and GPU to see the difference.</div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {showQuote && (
            <div onClick={() => { if (!quoteSending) { setShowQuote(false); setQuoteError(''); setQuoteSent(false); } }} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '16px' }}>
              <div onClick={e => e.stopPropagation()} className="p-quote-modal" style={{ background: '#060d18', border: '1px solid rgba(224,234,204,0.1)', borderRadius: '16px', padding: '40px 32px' }}>
                <button onClick={() => { if (!quoteSending) { setShowQuote(false); setQuoteError(''); setQuoteSent(false); } }} style={{ position: 'absolute', top: '16px', right: '20px', background: 'transparent', border: 'none', color: 'rgba(202,217,227,0.4)', cursor: 'pointer', fontSize: '18px', minWidth: '44px', minHeight: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
                {quoteSent ? (
                  <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <div style={{ fontSize: '20px', fontWeight: 700, color: '#fff', marginBottom: '8px' }}>We'll be in touch.</div>
                    <div style={{ fontSize: '13px', color: 'rgba(202,217,227,0.4)' }}>We'll get back to you with tailored pricing.</div>
                  </div>
                ) : (
                  <>
                    <div style={{ fontSize: '20px', fontWeight: 700, color: '#fff', marginBottom: '4px', textAlign: 'center' }}>Let's Talk</div>
                    <div style={{ fontSize: '13px', color: 'rgba(202,217,227,0.4)', marginBottom: '24px', textAlign: 'center' }}>We'll get back to you with tailored pricing.</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                      <div>
                        <label style={labelStyle}>Email</label>
                        <input type="email" value={qEmail} onChange={e => setQEmail(e.target.value)} placeholder="you@company.com" style={{ width: '100%', backgroundColor: 'rgba(10,26,46,0.6)', border: '1px solid rgba(224,234,204,0.1)', borderRadius: '8px', padding: '14px 14px', color: '#fff', fontSize: '15px', outline: 'none', boxSizing: 'border-box', minHeight: '48px' }} />
                      </div>
                      <div className="p-quote-grid">
                        <div>
                          <label style={labelStyle}>GPU</label>
                          <select value={qGpu} onChange={e => setQGpu(e.target.value)} style={{ ...selectStyle, boxSizing: 'border-box' }}>
                            {gpuKeys.map(g => <option key={g} value={g} style={{ background: '#040911' }}>{NAMES[g]}</option>)}
                          </select>
                        </div>
                        <div>
                          <label style={labelStyle}>Duration</label>
                          <select value={qMonths} onChange={e => setQMonths(e.target.value)} style={{ ...selectStyle, boxSizing: 'border-box' }}>
                            {['1','3','6','12','24'].map(m => <option key={m} value={m} style={{ background: '#040911' }}>{m} month{m!=='1'?'s':''}</option>)}
                          </select>
                        </div>
                      </div>
                      <button onClick={handleSendQuote} disabled={quoteSending || !qEmail} onMouseEnter={() => setHov('qs')} onMouseLeave={() => setHov(null)} style={{ width: '100%', background: accent, color: '#000', border: 'none', borderRadius: '10px', padding: '16px', fontSize: '16px', fontWeight: 600, cursor: quoteSending || !qEmail ? 'not-allowed' : 'pointer', transition: 'all 0.2s ease', transform: hov==='qs' && !quoteSending ? 'translateY(-1px)' : 'none', marginTop: '4px', opacity: quoteSending || !qEmail ? 0.5 : 1, minHeight: '52px' }}>{quoteSending ? 'Submitting...' : 'Submit'}</button>
                      {quoteError && <div style={{ fontSize: '12px', color: 'rgba(204,85,85,0.7)', textAlign: 'center' }}>{quoteError}</div>}
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </section>

        {/* ═══ S6: STORAGE ═══ */}
        <section data-section="storage" className="p-section-pad" style={{ background: '#040911', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: '15%', right: '-6%', width: '500px', height: '500px', background: 'radial-gradient(circle, rgba(10,26,46,0.4) 0%, transparent 70%)', borderRadius: '50%' }} />
          <div style={{ position: 'absolute', bottom: '10%', left: '-4%', width: '400px', height: '400px', background: 'radial-gradient(circle, rgba(224,234,204,0.025) 0%, transparent 70%)', borderRadius: '50%' }} />
          <div className="p-stor-inner p-section-inner" style={{ position: 'relative', zIndex: 10 }}>
            <div className="p-stor-header" style={fade(storVis)}>
              <div>
                <h2 style={{ fontSize: 'clamp(26px, 3.5vw, 42px)', fontWeight: 700, color: '#fff', marginBottom: '10px', letterSpacing: '-1px' }}>Storage. Same <span style={{ color: accent }}>Transparency.</span></h2>
                <p style={{ fontSize: 'clamp(13px, 1.5vw, 15px)', color: 'rgba(202,217,227,0.4)', margin: 0 }}>Volumes and snapshots. Priced per hour. No surprises here either.</p>
              </div>
              <div style={{ display: 'flex', borderRadius: '10px', overflow: 'hidden', border: '1px solid rgba(202,217,227,0.06)', flexShrink: 0 }}>
                {['USD', 'EUR', 'INR'].map(c => (
                  <button key={c} onClick={() => setStorCur(c)} style={{ padding: '10px 20px', fontSize: '13px', fontWeight: 500, border: 'none', cursor: 'pointer', transition: 'all 0.2s ease', background: storCur === c ? accent : '#060d18', color: storCur === c ? '#000' : 'rgba(202,217,227,0.5)', minHeight: '44px' }}>{c}</button>
                ))}
              </div>
            </div>
            <div style={{ background: '#060d18', border: '1px solid rgba(202,217,227,0.08)', borderRadius: '14px', overflow: 'hidden', ...fade(storVis, 0.3) }}>
              <div className="p-stor-grid" style={{ borderBottom: '1px solid rgba(202,217,227,0.06)' }}>
                <span style={{ fontSize: '11px', fontWeight: 600, color: 'rgba(202,217,227,0.25)', textTransform: 'uppercase', letterSpacing: '1px' }}>Type</span>
                <span className="p-stor-col-tier" style={{ fontSize: '11px', fontWeight: 600, color: 'rgba(202,217,227,0.25)', textTransform: 'uppercase', letterSpacing: '1px' }}>Tier</span>
                <span style={{ fontSize: '11px', fontWeight: 600, color: 'rgba(202,217,227,0.25)', textTransform: 'uppercase', letterSpacing: '1px', textAlign: 'right' }}>Per TB / hr</span>
                <span className="p-stor-col-mo" style={{ fontSize: '11px', fontWeight: 600, color: 'rgba(202,217,227,0.25)', textTransform: 'uppercase', letterSpacing: '1px', textAlign: 'right' }}>100GB / mo</span>
              </div>
              {storRows.map((row, i) => {
                const isH = storHov === row.label;
                const isAdv = row.tier === 'Advanced';
                const tierChange = i > 0 && storRows[i].tier !== storRows[i - 1].tier;
                return (
                  <div key={row.label}>
                    {tierChange && <div style={{ padding: '0 28px' }}><div style={{ borderTop: '1px solid rgba(224,234,204,0.06)' }} /></div>}
                    <div onMouseEnter={() => setStorHov(row.label)} onMouseLeave={() => setStorHov(null)} className="p-stor-row" style={{ background: isH ? 'rgba(224,234,204,0.02)' : 'transparent', transition: 'background 0.2s ease', cursor: 'default', opacity: storVis ? 1 : 0, transform: storVis ? 'translateY(0)' : 'translateY(10px)', transitionDelay: `${0.4 + i * 0.08}s` }}>
                      <div>
                        <span style={{ fontSize: '15px', fontWeight: 600, color: '#fff' }}>{row.label}</span>
                        {row.note && <span style={{ fontSize: '11px', color: 'rgba(202,217,227,0.2)', marginLeft: '8px' }}>{row.note}</span>}
                      </div>
                      <div className="p-stor-cell-tier">
                        <span style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '0.5px', padding: '3px 10px', borderRadius: '4px', color: isAdv ? accent : 'rgba(202,217,227,0.45)', background: isAdv ? 'rgba(224,234,204,0.06)' : 'rgba(202,217,227,0.04)', border: `1px solid ${isAdv ? 'rgba(224,234,204,0.1)' : 'rgba(202,217,227,0.06)'}` }}>{row.tier}</span>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <span style={{ fontSize: '16px', fontWeight: 700, color: isH ? '#fff' : 'rgba(255,255,255,0.9)', transition: 'color 0.2s ease' }}>{cs[storCur]}{fH(row.p[storCur])}</span>
                      </div>
                      <div className="p-stor-cell-mo" style={{ textAlign: 'right' }}>
                        <span style={{ fontSize: '14px', color: isH ? 'rgba(202,217,227,0.5)' : 'rgba(202,217,227,0.25)', transition: 'color 0.2s ease' }}>≈ {cs[storCur]}{ex100(row.p[storCur])}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="p-stor-notes" style={fade(storVis, 0.6)}>
              {['Billed per hour', 'Min volume: 100GB', 'Snapshots on Legacy only'].map((n, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <div style={{ width: '4px', height: '4px', borderRadius: '50%', background: 'rgba(202,217,227,0.15)' }} />
                  <span style={{ fontSize: '12px', color: 'rgba(202,217,227,0.2)' }}>{n}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ═══ S8: FAQ ═══ */}
        <section data-section="faq" className="p-section-pad" style={{ background: '#040911', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: '15%', left: '-6%', width: '500px', height: '500px', background: 'radial-gradient(circle, rgba(10,26,46,0.4) 0%, transparent 70%)', borderRadius: '50%' }} />
          <div className="p-faq-inner p-section-inner" style={{ position: 'relative', zIndex: 10 }}>
            <div style={{ marginBottom: '48px', ...fade(faqVis) }}>
              <h2 style={{ fontSize: 'clamp(26px, 3.5vw, 42px)', fontWeight: 700, color: '#fff', marginBottom: '10px', letterSpacing: '-1px' }}>Frequently <span style={{ color: accent }}>Asked.</span></h2>
              <p style={{ fontSize: 'clamp(13px, 1.5vw, 15px)', color: 'rgba(202,217,227,0.4)', margin: 0 }}>The short answers to the common questions.</p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', ...fade(faqVis, 0.3) }}>
              {faqs.map((faq, i) => {
                const isOpen = faqOpen === i;
                const isLast = i === faqs.length - 1;
                return (
                  <div key={i} style={{ borderBottom: !isLast ? '1px solid rgba(202,217,227,0.06)' : 'none' }}>
                    <button onClick={() => setFaqOpen(faqOpen === i ? null : i)} className="p-faq-btn" style={{ width: '100%', background: 'transparent', border: 'none', padding: '24px 0', cursor: 'pointer', textAlign: 'left', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}>
                      <span style={{ fontSize: 'clamp(14px, 1.6vw, 16px)', fontWeight: 600, color: isOpen ? '#fff' : 'rgba(202,217,227,0.7)', transition: 'color 0.25s ease' }}>{faq.q}</span>
                      <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: isOpen ? 'rgba(224,234,204,0.08)' : 'rgba(202,217,227,0.04)', border: `1px solid ${isOpen ? 'rgba(224,234,204,0.15)' : 'rgba(202,217,227,0.06)'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.25s ease', flexShrink: 0 }}>
                        <span style={{ fontSize: '16px', color: isOpen ? accent : 'rgba(202,217,227,0.3)', transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)', transition: 'all 0.3s cubic-bezier(0.25,0.46,0.45,0.94)', display: 'inline-block', lineHeight: 1 }}>+</span>
                      </div>
                    </button>
                    <div style={{ maxHeight: isOpen ? '200px' : '0px', overflow: 'hidden', transition: 'max-height 0.4s cubic-bezier(0.25,0.46,0.45,0.94)' }}>
                      <div style={{ paddingBottom: '24px', paddingRight: '44px' }}>
                        <p style={{ fontSize: 'clamp(13px, 1.5vw, 15px)', color: 'rgba(202,217,227,0.45)', lineHeight: 1.7, margin: 0 }}>{faq.a}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* ═══ S9: FOOTER ═══ */}
        <footer style={{ background: '#000', borderTop: '1px solid rgba(202,217,227,0.06)', padding: '48px 20px' }}>
          <div className="p-footer-inner">
            <span style={{ fontSize: '18px', fontWeight: 700, color: '#fff', letterSpacing: '-0.5px' }}>Barrack<span style={{ color: accent, opacity: 0.5 }}>™</span></span>
            <div className="p-footer-links">
              <a href="https://docs.barrack.ai" style={{ color: 'rgba(202,217,227,0.6)', fontSize: '13px', textDecoration: 'none', transition: 'color 0.2s ease' }} onMouseEnter={e => e.target.style.color='#fff'} onMouseLeave={e => e.target.style.color='rgba(202,217,227,0.6)'}>Docs</a>
              <a href="/blog" style={{ color: 'rgba(202,217,227,0.6)', fontSize: '13px', textDecoration: 'none', transition: 'color 0.2s ease' }} onMouseEnter={e => e.target.style.color='#fff'} onMouseLeave={e => e.target.style.color='rgba(202,217,227,0.6)'}>Blog</a>
              <span style={{ width: '1px', height: '14px', background: 'rgba(202,217,227,0.06)', alignSelf: 'center' }} />
              <a href="/privacy-policy" style={{ color: 'rgba(202,217,227,0.6)', fontSize: '13px', textDecoration: 'none', transition: 'color 0.2s ease' }} onMouseEnter={e => e.target.style.color='#fff'} onMouseLeave={e => e.target.style.color='rgba(202,217,227,0.6)'}>Privacy</a>
              <a href="/terms-of-service" style={{ color: 'rgba(202,217,227,0.6)', fontSize: '13px', textDecoration: 'none', transition: 'color 0.2s ease' }} onMouseEnter={e => e.target.style.color='#fff'} onMouseLeave={e => e.target.style.color='rgba(202,217,227,0.6)'}>Terms</a>
              <a href="/data-processing-agreement" style={{ color: 'rgba(202,217,227,0.6)', fontSize: '13px', textDecoration: 'none', transition: 'color 0.2s ease' }} onMouseEnter={e => e.target.style.color='#fff'} onMouseLeave={e => e.target.style.color='rgba(202,217,227,0.6)'}>DPA</a>
            </div>
            <span style={{ fontSize: '12px', color: 'rgba(202,217,227,0.55)' }}>© 2026 Barrack™. All rights reserved.</span>
          </div>
        </footer>

      </div>
    </>
  );
}